import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { LogIn } from "lucide-react";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      toast.success("Velkomin!");
      navigate("/admin/dashboard");
    } else {
      toast.error(result.error || "Innskráning mistókst");
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 via-background to-secondary-50 p-6">
      <div className="w-full max-w-md">
        <div className="bg-white border border-neutral-200 rounded-2xl shadow-xl p-8 md:p-12">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary-100 mb-4">
              <LogIn className="w-8 h-8 text-primary-600" />
            </div>
            <h1 className="text-3xl md:text-4xl font-display font-bold text-foreground mb-2">
              Admin Innskráning
            </h1>
            <p className="text-muted-foreground font-body">
              Skráðu þig inn til að stjórna eigninni
            </p>
          </div>

          <form onSubmit={handleSubmit} data-testid="login-form">
            <div className="space-y-6">
              <div>
                <Label htmlFor="email" className="text-sm font-ui font-medium text-neutral-700 mb-2 block">
                  Netfang
                </Label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="admin@example.com"
                  className="px-4 py-3 rounded-lg"
                  data-testid="form-input-email"
                />
              </div>

              <div>
                <Label htmlFor="password" className="text-sm font-ui font-medium text-neutral-700 mb-2 block">
                  Lykilorð
                </Label>
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="••••••••"
                  className="px-4 py-3 rounded-lg"
                  data-testid="form-input-password"
                />
              </div>

              <Button
                type="submit"
                disabled={loading}
                className="w-full bg-primary hover:bg-primary-600 hover:text-white text-white px-8 py-4 rounded-full font-ui font-medium tracking-wide shadow-lg shadow-primary-200/50 hover:shadow-xl transition-all duration-200"
                data-testid="login-submit-button"
              >
                {loading ? "Skráir inn..." : "Skrá inn"}
              </Button>
            </div>
          </form>

          <div className="mt-8 text-center">
            <a
              href="/"
              className="text-sm text-muted-foreground hover:text-foreground font-body transition-colors"
              data-testid="back-to-home-link"
            >
              ← Aftur á forsíðu
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;